<template lang="html">
  <div class="w-full bg-white">
    <ul class='tabs__header'>
      <li v-for='(tab, index) in tabs'
          :key='tab.title'
          @click='selectTab(index)'
          :class='{"tab__selected": (index == selectedIndex)}'>
        {{ tab.title }}
      </li>
      <li v-if="showNewTab" class="" @click.prevent="fireAddNewTabEvent">+</li>
    </ul>
    <slot v-bind:selectedIndex="selectedIndex"></slot>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: 'light'
    },
    showNewTab: false
  },
  data () {
    return {
      selectedIndex: 0, // the index of the selected tab,
      tabs: []         // all of the tabs
    }
  },
  created () {
    this.tabs = this.$children
  },
  mounted () {
    this.selectTab(0)
  },
  methods: {
    selectTab (i) {
      this.selectedIndex = i

      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = (index === i)
      })
    },
    fireAddNewTabEvent() {
      this.$emit('addtab')
    }

  }
}
</script>

<style lang="css">

ul.tabs__header {
  @apply bg-gray-200 p-0 m-0 block list-none px-2;
}

ul.tabs__header > li {
  @apply bg-gray-100 mx-1 mt-3 inline-block cursor-pointer px-6 py-2
}

ul.tabs__header > li.tab__selected {
  @apply font-bold border-t-2 border-black bg-white;
}

.tab {
  display: inline-block;
  color: black;
  padding: 20px;
  min-width: 800px;
  border-radius: 10px;
  min-height: 400px;
}

.tabs__light .tab{
  background-color: #fff;
}

.tabs__light li {
  background-color: #ddd;
  color: #aaa;
}

.tabs__light li.tab__selected {
  background-color: #fff;
  color: #83FFB3;
}

.tabs__dark .tab{
  background-color: #555;
  color: #eee;
}

.tabs__dark li {
  background-color: #ddd;
  color: #aaa;
}

.tabs__dark li.tab__selected {
  background-color: #555;
  color: white;

}

</style>
